import { useCartStep } from './useCartStep'
import { CartStepUI } from './CartStepUI'
import {} from '../../types'

export const CartStep = () => {
  const props = useCartStep()
  return <CartStepUI {...props} />
}
